var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNuacom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 36,
    viewBox: "0 0 242 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1668 3.63647H76.4168V31.512H73.1521V31.5499L58.5242 12.7183V31.4868H53.2932V3.63647H57.5473L71.1858 20.8925L71.1668 3.63647Z",
    fill: "#3D505A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.618 3.69312V19.6382C109.618 27.8692 104.576 32.0792 97.5676 32.0792C90.887 32.0792 85.2023 28.0267 85.2023 19.6382V3.69312H90.4144V19.6382C90.4144 24.6801 93.2757 27.3082 97.6054 27.3082C101.935 27.3082 104.406 24.4343 104.406 19.6382V3.69312H109.618Z",
    fill: "#3D505A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.687 26.2369H122.134L119.752 31.4868H114.08L126.546 3.63647H132.275L144.754 31.4679H139.006L136.687 26.2369ZM129.407 9.49772L124.239 21.3463H134.594L129.407 9.49772Z",
    fill: "#3D505A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.262 27.6298C171.567 30.3074 167.92 31.8077 164.121 31.802C154.737 31.802 149.846 25.2412 149.808 17.7287C149.771 10.2162 154.579 3.33401 164.121 3.33401C167.922 3.32719 171.569 4.83021 174.262 7.51251L172.787 8.77299C171.647 7.64146 170.294 6.74656 168.807 6.13977C167.32 5.53298 165.727 5.22629 164.121 5.23734C156.01 5.23734 151.838 10.9599 151.876 17.6405C151.957 24.1635 156.092 29.8104 164.121 29.8104C167.376 29.8153 170.503 28.5436 172.831 26.2685L174.262 27.6298Z",
    fill: "#3D505A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.333 17.6089C208.295 24.926 203.644 31.9595 194.297 31.9595C184.951 31.9595 180.262 24.8819 180.262 17.5017C180.262 10.0334 184.906 3.18896 194.291 3.18896C203.675 3.18896 208.37 10.0964 208.333 17.6089ZM182.373 17.5711C182.411 23.8735 186.388 29.9742 194.297 29.9742C202.207 29.9742 206.272 23.8546 206.272 17.5711C206.272 11.13 202.295 5.20573 194.297 5.20573C186.299 5.20573 182.329 11.0103 182.367 17.5711H182.373Z",
    fill: "#3D505A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.895 6.78768L229.238 23.0542H228.5L217.786 6.78768V31.5183H215.637V3.63647H218.158L228.815 19.8589L239.372 3.63647H242V31.4679H239.895V6.78768Z",
    fill: "#3D505A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7811 35.1801C20.4324 35.1801 18.9955 31.8335 16.3359 17.8358C14.7287 9.30866 12.8317 0 10.8149 0H22.6509C24.1193 0 25.7517 5.04193 28.0962 17.3568C30.1129 27.9638 31.7326 35.1801 33.6297 35.1801H21.7811Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8296 35.1801C13.1783 35.1801 14.6216 31.8335 17.2749 17.8358C18.8946 9.27715 20.798 0 22.8084 0H10.9788C9.51034 0 7.87171 5.04193 5.53352 17.3568C3.51675 27.9638 1.89072 35.1801 0 35.1801H11.8296",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5855 35.1801C34.9343 35.1801 36.3775 31.8335 39.0308 17.8358C40.6505 9.27715 42.5539 0 44.5643 0H32.7347C31.2663 0 29.6276 5.04193 27.2894 17.3568C25.2664 27.9638 23.6719 35.1801 21.7811 35.1801H33.6171",
    fill: "#62BB46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3485 17.8359C16.5123 18.6678 16.6636 19.4682 16.8148 20.2308C16.9661 19.4682 17.1174 18.6678 17.2749 17.8359C18.8757 9.37803 20.7539 0.22063 22.7391 0.00634766H10.8843C12.8758 0.22063 14.7477 9.37803 16.3485 17.8359Z",
    fill: "#0092C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0835 17.3568C27.9449 16.6384 27.8125 15.9451 27.6802 15.2708C27.5478 15.9451 27.4092 16.6384 27.2768 17.3568C25.2727 27.9323 23.6719 35.1486 21.7811 35.1801H33.6234C31.7263 35.1486 30.1066 27.9323 28.0835 17.3568Z",
    fill: "#4F9D3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 242,
    height: 35.1864,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNuacom);
export default __webpack_public_path__ + "static/media/logo-nuacom.330494e0b3dfc2b46bc1413c009100c4.svg";
export { ForwardRef as ReactComponent };